import { render } from "./WalletBonus.vue?vue&type=template&id=4f994d40"
import script from "./WalletBonus.vue?vue&type=script&lang=js"
export * from "./WalletBonus.vue?vue&type=script&lang=js"

import "./WalletBonus.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__